import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, onValue } from 'firebase/database';

const Namuna8Report = () => {
  const { id } = useParams();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      const recordRef = ref(database, `Grampanchayat/Gramniddhi/NewMilakhatRecords/${id}`);
      onValue(recordRef, (snapshot) => {
        const data = snapshot.val();
        setRecord(data);
        setLoading(false);
      });
    }
  }, [id]);

  if (loading) return <div className="p-4 text-center">Loading...</div>;
  if (!record) return <div className="p-4 text-center text-red-500">Record not found</div>;

  const handlePrint = () => {
    window.print();
  };

  const taxes = record.taxData || {};
  const houseTax = taxes.houseTax || { current: 0 };
  const healthTax = taxes.healthTax || { current: 0 };
  const lightTax = taxes.electricityTax || { current: 0 }; // Using light tax for "दिवाबत्ती" if needed, usually Form 8 has specific cols
  const waterTax = taxes.waterTax || { current: 0 };
  const totalTax = taxes.total || { current: 0 };

  // Date format
  const currentDate = new Date().toLocaleDateString('en-GB');

  return (
    <div id="printable-content" className="bg-white min-h-screen p-4 text-[11px] font-serif text-black leading-tight">
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          body {
            -webkit-print-color-adjust: exact;
          }
          #printable-content, #printable-content * {
            visibility: visible;
          }
          #printable-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          @page { size: landscape; margin: 5mm; }
          .no-print { display: none !important; }
        }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid black; padding: 2px 4px; vertical-align: middle; }
        .thick-border { border: 2px solid black; }
      `}</style>

      {/* Print Button */}
      <div className="max-w-screen-xl mx-auto mb-4 no-print flex justify-end">
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 font-bold"
        >
          Print / Save PDF
        </button>
      </div>

      <div className="w-fit mx-auto border-2 border-black p-1">

        {/* Header Block */}
        <div className="grid grid-cols-12 border-b-2 border-black">
          {/* Left Box: Village Info */}
          <div className="col-span-3 border-r border-black p-2">
            <p className="font-bold">ग्रामपंचायत इनाम धामणी</p>
            <div className="mt-2 grid grid-cols-[50px_1fr] gap-1">
              <span>गाव :</span>
              <span className="font-bold">इनाम धामणी</span>
              <span>तालुका :</span>
              <span className="font-bold">मिरज</span>
              <span>जिल्हा :</span>
              <span className="font-bold">सांगली</span>
            </div>
          </div>

          {/* Center Box: Title */}
          <div className="col-span-7 border-r border-black text-center p-2">
            <h1 className="text-xl font-bold">ग्रामपंचायत नमुना नं. ८ उतारा (नक्कल)</h1>
            <p className="text-sm font-bold">नियम ३२ (१)</p>
            <p className="mt-1 font-semibold">सन २०२५-२०२६ ते २०२९-२०३० सालासाठी करास पात्र असलेल्या इमारती व जमिनी यांची</p>
            <h2 className="text-lg font-bold">आकारणी यादी (असेसमेंट लिस्ट)</h2>
          </div>

          {/* Right Box: Legal Refs */}
          <div className="col-span-2 text-center p-2 flex flex-col justify-between">
            <div className="border border-black p-1 mb-1">
              <p>महाराष्ट्राचा</p>
              <p>ग्रामपंचायतचा कायदा</p>
            </div>
            <div className="border border-black h-16 flex items-center justify-center">
              ग्रामपंचायत चा शिक्का
            </div>
          </div>
        </div>

        {/* Main Table */}
        <table className="w-full text-center">
          <thead>
            {/* Column Headers */}
            <tr className="bg-gray-100">
              <th rowSpan="3" className="w-8">अ.क्र</th>
              <th rowSpan="3" className="w-16">प्रभाग नाव/न. गट क्र./भु.मा.पन.क्र./नगर भु.मा.पन</th>
              <th rowSpan="3" className="w-12">मालमत्ता क्र.</th>
              <th rowSpan="3" className="w-48">मालकाचे नाव</th>
              <th rowSpan="3" className="w-24">भोगवटादाराचे नाव</th>
              <th rowSpan="3" className="w-32">मालमत्तेचे वर्णन</th>
              <th colSpan="2">मिळकत</th>
              <th colSpan="3">वार्षिक मूल्य दर तथा प्रति चौ.मी. (रुपये)/ बांधकाम</th>
              <th rowSpan="3">घसारा दर</th>
              <th rowSpan="3">इमारतीचा वापरानुसार भारांक</th>
              <th rowSpan="3">भांडवली मुल्य (रु.पै.)</th>
              <th rowSpan="3">करावयाचा दर (रु.पै.)</th>
              <th colSpan="5">कराची रक्कम (रुपये)</th>
              <th colSpan="5">अपिलाचे निकाल आणि त्यानंतर केलेले फेरफार(रुपये)</th>
            </tr>
            <tr className="bg-gray-100">
              <th rowSpan="2">बांधकामाचे वर्ष (मिळकतीचे वयोमान वर्षामध्ये)</th>
              <th rowSpan="2">क्षेत्रफळ चौ.फु/चौ.मी.</th>
              <th rowSpan="2">जमिन</th>
              <th rowSpan="2">इमारत</th>
              <th rowSpan="2">इतर</th>

              {/* Tax Cols */}
              <th>घरपट्टी</th>
              <th>दिवाबत्ती</th>
              <th>आरोग्य</th>
              <th>पाणी पट्टी</th>
              <th>एकुण</th>

              {/* Appeal Cols */}
              <th>घरपट्टी</th>
              <th>दिवाबत्ती</th>
              <th>आरोग्य</th>
              <th>पाणी पट्टी</th>
              <th>एकुण</th>
            </tr>
            <tr className="bg-gray-100">
              {/* Numbering Row (Matches Image (1) to (26)) */}
              {/* Cols 1-6 are rowspanned */}
              {/* Cols 7-8 */}
              {/* Cols 9-11 */}
              {/* Cols 12-14 */}
              {/* Cols 15-16 */}
              {/* Cols 17-21 */}
              {/* Cols 22-26 */}
            </tr>
            <tr className="text-[10px]">
              <th>(१)</th><th>(२/३)</th><th>(४)</th><th>(५)</th><th>(६)</th><th>(७)</th>
              <th>(८)</th><th>(९)</th>
              <th>(१०/११/१२)</th><th></th><th></th> {/* Merged logic simplified for display */}
              <th>(१३)</th><th>(१४)</th><th>(१५)</th><th>(१६)</th>
              <th>(१७)</th><th>(१८)</th><th>(१९)</th><th>(२०)</th><th>(२१)</th>
              <th>(२२)</th><th>(२३)</th><th>(२४)</th><th>(२५)</th><th>(२६)</th>
            </tr>
          </thead>
          <tbody>
            {/* Data Row */}
            {/* Usually Form 8 lists sub-properties (floors/rooms) as separate rows if detailed, 
                     or one main row. Using propertyRecords array if multiple exist. */}
            {(record.propertyRecords && record.propertyRecords.length > 0 ? record.propertyRecords : [record]).map((subRecord, index) => (
              <tr key={index} className="h-16">
                <td>{index + 1}</td>
                <td>{record.wardName || '-'}</td>
                <td>{record.propertyNo}</td>
                <td className="text-left px-2 font-bold">{record.mainOwner}</td>
                <td>{record.occupierName || 'स्वत:'}</td>
                <td className="text-left px-2">{subRecord.propertyDescription || subRecord.propertyType}</td>

                <td>{subRecord.constructionDate ? subRecord.constructionDate.split('/').pop() : '-'}</td>
                <td>
                  <div>{subRecord.area} <span className="text-[9px]">चौ.फु.</span></div>
                  <div className="border-t border-black mt-1">{subRecord.areaSqKm} <span className="text-[9px]">चौ.मी.</span></div>
                </td>

                {/* Rate Cols - Mocked or from data if available */}
                <td>1760</td> {/* Land Rate */}
                <td>-</td>
                <td>-</td>

                <td>1.00</td> {/* Depreciation */}
                <td>1.00</td> {/* Usage Factor */}

                <td className="font-bold">{subRecord.capitalValue}</td>
                <td>{/* Tax Rate % */} - </td>

                {/* Tax Amounts */}
                <td>{subRecord.houseTax || houseTax.current}</td>
                <td>{subRecord.electricityTaxVal || lightTax.current}</td>
                <td>{subRecord.healthTaxVal || healthTax.current}</td>
                <td>{waterTax.current || '-'}</td>
                <td className="font-bold">
                  {(parseInt(subRecord.houseTax || 0) + parseInt(subRecord.electricityTaxVal || 0) + parseInt(subRecord.healthTaxVal || 0)).toString()}
                </td>

                {/* Appeal Columns - Empty for now */}
                <td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>
              </tr>
            ))}

            {/* Total Row */}
            <tr className="font-bold bg-gray-50">
              <td colSpan="17" className="text-right px-2">एकुण :</td>
              <td>{houseTax.current}</td>
              <td>{lightTax.current}</td>
              <td>{healthTax.current}</td>
              <td>{waterTax.current || '-'}</td>
              <td>{totalTax.current}</td>
              <td colSpan="5"></td>
            </tr>

          </tbody>
        </table>

        {/* Footer */}
        <div className="mt-2 border-t-2 border-black pt-1">


          <div className="flex justify-between items-end px-4">
            <div>
              <p>नक्कल देय तारीख : {currentDate}</p>
            </div>

            {/* QR & Signatures */}
            <div className="flex gap-16 text-center">
              <div>
                <div className="h-20 w-20 mx-auto mb-1 flex items-center justify-center">
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(window.location.href)}`}
                    alt="QR Code"
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="text-[10px]">येणे प्रमाणे अस्सल हुकुमनक्कल अर्जदार श्री /सौ.</p>
              </div>


            </div>
          </div>

        </div>

      </div>

      {/* Footer Text Outside Border */}
      <div className="max-w-screen-xl mx-auto mt-2 text-[11px] font-bold">
        <p className="mb-1">सदरचा उतारा हा मालकी हक्काचा नसून करआकारणीचा आहे. सदरच्या उताऱ्यावरून खरेदी विक्रीचा व्यवहार झालेस त्यास ग्रामपंचायत जबाबदार राहणार नाही.</p>
        <p className="mb-2">शासन परिपत्रक क्र. VTM२६०३/प्र.क्र. २०६८ /पं.रा. ४ दि. २० नोव्हेंबर २००३ नुसार ग्रामीण भागातील घरांची नोंदणी पती-पत्नी यांच्या संयुक्त नांवे करण्याबाबत निर्देशित करण्यात आलेले आहे.</p>



      </div>
    </div>
  );
};

export default Namuna8Report;
